
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[projectId]",
      function () {
        return require("private-next-pages/project/[projectId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/[projectId]"])
      });
    }
  